const baseRotation = {
  x: Math.PI * 0.1,
  y: (Math.PI / 4) * 3,
  z: 0,
};


let clientX = window.innerWidth / 2,
  clientY = window.innerHeight / 2;
let isNewSession = false;
let blockTriggers = false;
let currentDirection;
let currentVelocity;
let currentScroll;
let isLowEndDevice = false;
